import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../hooks';
import { createDeepEqualSelector } from '../selector.helpers';
import { GlobalQueryParams } from './queryParams.interface';

export interface GlobalQueryState {
  queryParams: GlobalQueryParams;
}

export const initialGlobalQueryState: GlobalQueryState = {
  queryParams: {},
};

/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
export const globalQuerySlice = createSlice({
  name: 'globalQuerySlice',
  initialState: initialGlobalQueryState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    // TODO: Maybe we need to only update queryParams if they have changed because all memoized selectors (i.e. createSelectors(...)) are recalculated by reference rather then by value? or use https://github.com/reduxjs/reselect#customize-equalitycheck-for-defaultmemoize in selectors to check by value
    dispatchGlobalQuery(state, action) {
      state.queryParams = {
        ...state.queryParams,
        ...action.payload,
      };

      // WARNING: DON'T REMOVE null values here
      // because useAltNavStates will put the values back since it has no way of knowing what is removed and what should stay from previous state
    },
  },
});

export const { dispatchGlobalQuery } = globalQuerySlice.actions;

export const globalQuerySelector = createDeepEqualSelector(
  (state: RootState): GlobalQueryParams => {
    // console.log('globalQuerySelector', state.globalView.queryParams);
    return state.globalQuery.queryParams;
  },
  (value) => {
    // console.log('globalQuerySelector value....', value);
    return value;
  },
);

// same as above but will be triggered more often since it is checking by reference.
export const queryParamsSelector = (state: RootState) => {
  return state.globalQuery.queryParams;
};
